import { render, staticRenderFns } from "./wTaxAccountResult.vue?vue&type=template&id=67ec2687&scoped=true&"
import script from "./wTaxAccountResult.vue?vue&type=script&lang=js&"
export * from "./wTaxAccountResult.vue?vue&type=script&lang=js&"
import style0 from "./wTaxAccountResult.vue?vue&type=style&index=0&id=67ec2687&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec2687",
  null
  
)

export default component.exports